import { render, staticRenderFns } from "./tableValueTenants.vue?vue&type=template&id=1c812419&scoped=true&"
import script from "./tableValueTenants.vue?vue&type=script&lang=js&"
export * from "./tableValueTenants.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=1c812419&scoped=true&lang=css&"
import style1 from "./tableValueTenants.vue?vue&type=style&index=1&id=1c812419&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c812419",
  null
  
)

export default component.exports